import React, { FunctionComponent } from "react";
import { graphql } from "gatsby";
import { Layout } from "../../components/layout";
import { BlogList } from "../../components/blogList";
import { SEO } from "../../components/seo";
import { PostSnippetNode, toPostSnippet } from "../../data/posts";

interface QueryData {
  data: {
    allMarkdownRemark: {
      nodes: PostSnippetNode[];
    };
  };
  pageContext: {
    currentPage: number;
    hasNext: boolean;
  };
}

export const pageQuery = graphql`
  query ($skip: Int!, $limit: Int!) {
    allMarkdownRemark(
      sort: { fields: [frontmatter___publishedDate], order: DESC }
      filter: { fields: { collection: { eq: "blog" } } }
      limit: $limit
      skip: $skip
    ) {
      nodes {
        ...PostSnippet
      }
    }
  }
`;

export const Page: FunctionComponent<QueryData> = ({ data, pageContext }) => {
  const posts = data.allMarkdownRemark.nodes.map(toPostSnippet);
  return (
    <>
      <SEO
        title={`Page ${pageContext.currentPage}`}
        image={posts[0].img.src}
        description={`Page ${pageContext.currentPage}`}
      />
      <Layout>
        <BlogList
          posts={posts}
          page={pageContext.currentPage}
          hasNext={pageContext.hasNext}
        />
      </Layout>
    </>
  );
};

export default Page;
